import { Guarantor } from "@ploy-lib/rest-resources";
import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";

export class GuarantorTableSchema implements IFormTableSchema<Guarantor> {
	tableMetadata: TableMetadata<Partial<Guarantor>> = {
		dployTesterContext: "Guarantor"
	};

	columnMetadata: Partial<Record<keyof Guarantor, ColumnMetadata<Guarantor>>> =
		{
			customerNumberCombined: { fieldType: FieldType.Text }
		};
}
